"use client";

import { Tabs as TabsPrimitive } from "@base-ui/react/tabs";
import { cn } from "../lib/utils";

// Compose with Tabs and TabsContent; only the navigation has a different look.
function UnderlineTabsList({ className, ...props }: TabsPrimitive.List.Props) {
  return (
    <TabsPrimitive.List
      data-slot="underline-tabs-list"
      {...props}
      className={(state) =>
        cn(
          "flex w-full gap-6 border-b border-border",
          typeof className === "function" ? className(state) : className,
        )
      }
    />
  );
}

function UnderlineTabsTrigger({
  className,
  ...props
}: TabsPrimitive.Tab.Props) {
  return (
    <TabsPrimitive.Tab
      data-slot="underline-tabs-trigger"
      {...props}
      className={(state) =>
        cn(
          "relative inline-flex min-h-11 shrink-0 cursor-pointer items-center justify-center gap-2 bg-transparent py-3 text-sm font-medium whitespace-nowrap text-text-secondary hover:text-foreground data-active:text-foreground focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 after:absolute after:inset-x-0 after:-bottom-px after:h-0.5 after:bg-transparent data-active:after:bg-accent",
          typeof className === "function" ? className(state) : className,
        )
      }
    />
  );
}

export { UnderlineTabsList, UnderlineTabsTrigger };
